module.exports = __webpack_public_path__ + "img/qrcode.1bcf3c27.png";